import { render, staticRenderFns } from "./cable.vue?vue&type=template&id=4467524f&"
import script from "./cable.vue?vue&type=script&lang=js&"
export * from "./cable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports